module.exports = __webpack_public_path__ + "system/img/newdef2.fffcf3f5.png";